import { Component, OnInit } from '@angular/core';
import { CXoneVoiceContact } from '@nice-devone/acd-sdk';
import { LoggerService } from 'src/app/core/services/logger.service';
import { LoginService } from 'src/app/core/services/login.service';
import { SdkAcdAgent } from 'src/app/data/CXOne/sdk-acd/sdk-acd.service';
import { NiceSdkAuthenticationService } from 'src/app/data/CXOne/sdk-auth/nice-sdk-authentication.service';
import { DynamicsMainService } from 'src/app/data/Dynamics/main-dynamics/dynamics-main.service';
import { Central } from 'src/app/data/Dynamics/main-dynamics/dynamics-retrieve-config';
import { EventHandlerService } from 'src/app/data/services/event-handler.service';
import { VoiceContactStatusAgent } from 'src/app/shared/enums/voice-contact-status-agent.enum';
import { GenericCreateRecordDynamics } from 'src/app/shared/models/main-dynamics/genericCreateRecordDynamics';
import { GenericCreateTicketDynamicsDTO } from 'src/app/shared/models/main-dynamics/genericCreateTicketDynamicsDTO';
import { environment } from 'src/environments/environment';
import { LocalStorageUtils } from 'src/app/data/CXOne/util/LocalStorageUtils';
import { JsonConverterUtils } from 'src/app/data/CXOne/util/JsonConverterUtils';

@Component({
  selector: 'app-rede-pj',
  standalone: true,
  imports: [],
  templateUrl: './rede-pj.component.html',
  styleUrl: './rede-pj.component.css',
})
export class RedePjComponent implements OnInit {
  loggerTag = 'REDE-PJ ';
  tableName = 'itau_interacao';
  constructor(
    private logger: LoggerService,
    private loginService: LoginService,
    private niceSdkAuthService: NiceSdkAuthenticationService,
    private sdkAcdAgent: SdkAcdAgent,
    private eventHandler: EventHandlerService,
    private dynamics: DynamicsMainService,
    private localStorageUtils: LocalStorageUtils,
    private jsonConverterUtils: JsonConverterUtils,
  ) {}

  public async intialization(): Promise<void> {
    const centralId =
      this.localStorageUtils.safeGetItem('centralId') || 'rede-pj';
    const authServiceType =
      this.localStorageUtils.safeGetItem('authServiceType') || 'nice';
    const authMode =
      this.localStorageUtils.safeGetItem('display_mode') || 'popup';
    try {
      const isAuthenticated = await this.loginService.login(
        authServiceType,
        centralId,
        true,
        authMode,
      );

      if (!isAuthenticated) {
        this.logger.info(this.loggerTag + 'Usuário não autenticado');
        return;
      }

      await this.niceSdkAuthService.launchAgent();
      await this.sdkAcdAgent.initialize();
      await this.dynamics.initialize(
        environment.cif_versao_2_redes_pf,
        Central.REDES,
      );
      await this.dynamics.loadTemplateValues();
      this.sdkAcdAgent.voiceContactUpdate$.subscribe(
        async (voiceContact: CXoneVoiceContact) => {
          this.logger.info(this.loggerTag + 'entrou evento de subscribe');
          const status = voiceContact.status || '';
          const contactId = voiceContact.contactID || '';
          const eventContact = { id: contactId, status: status };
          const processedEvent = this.eventHandler.isProcessed(eventContact);
          this.logger.info(this.loggerTag + 'evento processado.');

          //Evento de ligação - criação de ticket
          if (status === VoiceContactStatusAgent.ACTIVE && !processedEvent) {
            this.logger.info(this.loggerTag + 'VoiceActive moment');
            this.eventHandler.add(eventContact);
            this.processVoiceContactEvent(voiceContact);
          }

          //Evento de encerramento da chamada - fechamento do ticket.
          if (status === VoiceContactStatusAgent.DISCONNECTED) {
            this.eventHandler.remove(eventContact);
            this.endVoiceContactEvent(voiceContact);
          }
        },
      );
    } catch (error) {
      this.logger.error(error);
      window.alert('Falha no login');
    }
  }

  ngOnInit() {
    this.intialization();
  }

  private async processVoiceContactEvent(
    voiceContact: CXoneVoiceContact,
  ): Promise<void> {
    try {
      const contact = voiceContact.isInbound ? 'INBOUND' : 'OUTBOUND';

      if (contact === 'OUTBOUND') {
        this.logger.info(
          `REDE - Contato não é inbound, não executando a criação de ticket no dynamics.`,
        );

        return;
      }

      if (typeof (window as any).Microsoft === 'undefined') {
        this.logger.warn(
          'Função microsoft.Microsoft.Cif ainda não está disponível.',
        );
        return;
      }

      const attachdata = this.sdkAcdAgent.deserializeScreenPopUrl(
        voiceContact.screenPopUrl,
      );

      const attachJson = JSON.stringify(attachdata.u_json);

      const recordData: GenericCreateTicketDynamicsDTO = {
        'itau_u_lk_projeto@odata.bind': this.dynamics.templateValues
          .itau_u_lk as string,
        itau_mst_attachdata: attachJson,
        itau_name: this.dynamics.templateValues.itau_name as string,
        itau_u_nomeprojeto: this.dynamics.templateValues
          .itau_u_nomeprojeto as string,
        itau_st_id_conexao: voiceContact.contactID,
        //iresolve_st_plugin: attachdata.itau_name,
      };

      const dataTicket: GenericCreateRecordDynamics = {
        tableName: this.tableName,
        data: recordData,
        isFocused: true,
        contactCenterInteractionId: voiceContact.contactID,
      };

      this.logger.info(this.loggerTag + 'Dados do ticket', dataTicket);

      const result = await this.dynamics.openTicket(dataTicket);

      if (!result || !result.id_interacao || !result.id_ticket) {
        this.logger.error(this.loggerTag + '- Erro   ', result);
        return;
      }

      this.logger.info(
        this.loggerTag + '- fluxo de ticket executado com sucesso',
        result,
      );
    } catch (error) {
      this.eventHandler.remove({ id: voiceContact.contactID, status: '' });
      this.logger.error('- Erro ao processar contato de voz: ', error);
    }
  }

  private async endVoiceContactEvent(voiceContact: CXoneVoiceContact) {
    const sessionId = this.localStorageUtils.safeGetItem(
      voiceContact.contactID,
    );

    if (!sessionId) {
      this.logger.info(
        this.loggerTag +
          '- sessionId não encontrado no localStorage, não é possível encerrar',
        voiceContact.contactID,
      );
      return;
    }

    const context = {
      itau_cliente_on: false,
      itau_sessao_ativa: false,
    };

    this.logger.info(this.loggerTag + '- encerrando sessão', sessionId);

    await this.dynamics.closeTicket(context, sessionId);

    this.localStorageUtils.safeRemoveItem(voiceContact.contactID);
    this.localStorageUtils.safeRemoveItem(sessionId);
  }
}
